/**
 * Lets onboarding completion flip a mounted gate without a pathname refetch.
 * Completing onboarding usually unmounts the gate (it does not wrap
 * /studio/onboarding); this covers the mid-session transition if it stays mounted.
 */
type Listener = () => void;

const listeners = new Set<Listener>();

export function notifyStudioOnboardingCompleted(): void {
  listeners.forEach((listener) => listener());
}

export function subscribeStudioOnboardingCompleted(listener: Listener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
